export default [{ code: 'tableQueryModal', name: '宽表模板设置', icon: 'el-icon-s-home', parentKey: '', selfFlg: 'mould' }];
